<!-- Metadata container, displayed only if there are items to show -->
<div *ngIf="getTotalItems() > 0" class="metadata-container">
    <!-- Header Section -->
    <div class="metadata-header">
        <span class="metadata-title">
            <img src="../../../assets/images/chatbot-icon.svg" alt="Freya" class="metadata-icon" *ngIf="!isloader">
            <div class="metadata-loader m-r-8" *ngIf="isloader">
                <div class="spinner"></div>
            </div>
            <span class="nowrap"> {{'SOURCES_PANEL_TITLE' | translate}} </span>
            <button class="metadata-count" (click)="!isResponseStreaming && viewAllSources()" [disabled]="isResponseStreaming" >
                {{ getTotalItems() }}
            </button>
            
            <!-- Relevance Legend -->
            <div class="relevance-legend" 
                 [class.single-item]="getRelevanceLegend().length === 1"
                 [class.two-items]="getRelevanceLegend().length === 2"
                 *ngIf="hasRelevanceScores()">
                <div class="relevance-legend-item" *ngFor="let legend of getRelevanceLegend()">
                    <span class="relevance-legend-dot" [class]="legend.class"></span>
                    <span>{{ 
                        (legend.label === 'MOST_RELEVANT' ? 'MOST_RELEVANCE' : 
                        legend.label === 'MEDIUM_RELEVANT' ? 'MEDIUM_RELEVANCE' : 
                        legend.label === 'LESS_RELEVANT' ? 'LESS_RELEVANCE' :
                        legend.label) | translate 
                    }}</span>
                </div>
            </div>
        </span>
        <!-- View All Sources Button -->
        <div class="view-all-sources-container">
            <button class="view-all-sources-btn" (click)="viewAllSources()" *ngIf="!isResponseStreaming">
                {{'VIEW_ALL_SOURCES_BUTTON' | translate}}
            </button>
        </div>
    </div>

    <!-- Carousel Container -->
    <div class="carousel-container">
        <!-- Carousel Items -->
        <div class="carousel-items">
            <div class="sourcerow">
                <ng-container *ngFor="let item of getCurrentPageItems(); let i = index">
                    <div class="source-item m-b-10">
                        <div class="product-panel__bg1">
                            <div class="product_panel">
                                <!-- Universal Metadata Rendering -->
                                <ng-container *ngIf="getModuleName(item)">
                                    <!-- Header with ID and relevance -->
                                    <div class="insight-header">
                                        <a target="_blank" class="m-b-2"
                                            [href]="getViewUrl(item)" rel="noopener"
                                            *ngIf="getViewUrl(item)">
                                            <span class="relevance-dot" [class]="getRelevanceClass(getFieldValue(item, 'relevance_score'))" 
                                                  *ngIf="hasFieldValue(item, 'relevance_score')"></span>
                                            {{ getDisplayId(item) }}
                                        </a>
                                        <span *ngIf="!getViewUrl(item)" class="m-b-2">
                                            <span class="relevance-dot" [class]="getRelevanceClass(getFieldValue(item, 'relevance_score'))" 
                                                  *ngIf="hasFieldValue(item, 'relevance_score')"></span>
                                            {{ getDisplayId(item) }}
                                        </span>
                                    </div>

                                    <!-- Title (truncated with ellipsis like legacy path / image 1) -->
                                    <h4 *ngIf="getDisplayTitle(item)">
                                        <span *ngIf="item.key">{{item.key}}. </span>
                                        {{ getDisplayTitleTruncated(item) }}
                                    </h4>

                                    <!-- Compact View Fields -->
                                    <!-- Categories (compact for all modules) -->
                                    <ng-container *ngIf="getCategoryDisplay(item) as categoryDisplay">
                                        <span class="country-tag">
                                            <span class="country-text">
                                                {{ categoryDisplay.label }}
                                            </span>
                                        </span>
                                    </ng-container>

                                    <!-- Brand Names (compact for all modules) -->
                                    <ng-container *ngIf="displayBrandNames(item).firstTwo">
                                        <span class="country-tag">
                                            <span class="location-icon-wrapper">
                                                <img src="assets/images/brand-icon.svg" alt="Brand" 
                                                     class="location-icon" width="16" height="16">
                                            </span>
                                            <span class="country-text">
                                                {{ displayBrandNames(item).firstTwo }}
                                            </span>
                                            <span class="count-with-space" *ngIf="displayBrandNames(item).remainingCount > 0">
                                                +{{ displayBrandNames(item).remainingCount }}
                                            </span>
                                        </span>
                                    </ng-container>

                                    <!-- Countries (compact for all modules) -->
                                    <ng-container *ngIf="displayCountries(item).firstTwo">
                                        <span class="country-tag">
                                            <span class="location-icon-wrapper">
                                                <img src="assets/images/location.svg" alt="Location" 
                                                     class="location-icon" width="16" height="16">
                                            </span>
                                            <span class="country-text">
                                                {{ displayCountries(item).firstTwo }}
                                            </span>
                                            <span class="count-with-space" *ngIf="displayCountries(item).remainingCount > 0">
                                                +{{ displayCountries(item).remainingCount }}
                                            </span>
                                        </span>
                                    </ng-container>


                                    <!-- Fallback for legacy modules not in configuration -->
                                    <ng-container *ngIf="!getModuleName(item)">
                                        <!-- Legacy regulations rendering -->
                                        <ng-container *ngIf="selected_module_name === 'view_access_to_regulations'">
                                    <div class="insight-header">
                                        <a target="_blank" class="m-b-2"
                                            [href]="getViewUrl(item)" rel="noopener">
                                            <span class="relevance-dot" [class]="getRelevanceClass(item.relevance_score)" *ngIf="item.relevance_score"></span>
                                            {{item.ins_id}}
                                        </a>
                                    </div>
                                    <h4><span *ngIf="item.key">{{item.key}}. </span>{{item.title | slice:0:40}}{{item.title.length > 40 ? '...' : '' }}</h4>
                                    <span class="country-tag" *ngIf="extractBrandNames(item).length > 0">
                                        <span class="location-icon-wrapper">
                                                    <img src="assets/images/brand-icon.svg" alt="Brand" 
                                                         class="location-icon" width="16" height="16">
                                        </span>
                                        <span class="country-text">
                                            {{ displayBrandNames(item).firstTwo }}
                                        </span>
                                        <span class="count-with-space" *ngIf="displayBrandNames(item).remainingCount > 0">
                                            +{{ displayBrandNames(item).remainingCount }}
                                        </span>
                                    </span>
                                    <span class="country-tag">
                                        <span class="location-icon-wrapper" *ngIf="extractCountries(item).length > 0">
                                                    <img src="assets/images/location.svg" alt="Location" 
                                                         class="location-icon" width="16" height="16">
                                        </span>
                                        <span class="country-text">
                                            {{ displayCountries(item).firstTwo }}
                                        </span>
                                        <span class="count-with-space" *ngIf="displayCountries(item).remainingCount > 0">
                                            +{{ displayCountries(item).remainingCount }}
                                        </span>
                                    </span>
                                </ng-container>

                                        <!-- Legacy RTQ rendering -->
                                    <ng-container *ngIf="selected_module_name === 'view_access_to_rtq'">
                                        <div class="insight-header">
                                            <a target="_blank" class="m-b-2"
                                                [href]="getViewUrl(item)" rel="noopener">
                                                <span class="relevance-dot" [class]="getRelevanceClass(item.relevance_score)" *ngIf="item.relevance_score"></span>
                                                {{item.rtq_id}}
                                            </a>
                                        </div>
                                        <h4 *ngIf="item.query_title && item.query_title !== ''">
                                            <span *ngIf="item.key">{{item.key}}. </span>{{item.query_title | slice:0:40}}{{item.query_title.length > 40 ? '...' : '' }}
                                        </h4>
                                        <p class="p-b-10" *ngIf="item.product_id && item.product_id !== ''">
                                            <span>{{'PRODUCT_ID' | translate}} {{item.product_id}}</span>
                                        </p>
                                        <p class="product-info" *ngIf="item.productName && item.productName !== '' && item.productName !== null">
                                            <svg class="product-icon" viewBox="0 0 16 16" width="14" height="14">
                                                <path d="M2 2h12a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm0 1v10h12V3H2zm2 2h8v1H4V5zm0 2h8v1H4V7zm0 2h6v1H4V9z" fill="#666"/>
                                            </svg>
                                            {{item.productName}}
                                        </p>
                                        <p class="p-b-10" *ngIf="item.document_id">
                                            <span>
                                                {{'DOCUMENT_ID' | translate}}
                                                <a href="#" (click)="downloadDocument(item.document_id); $event.preventDefault()">
                                                    {{ item.document_id }}
                                                </a>
                                            </span>
                                        </p>
                                        <p class="p-b-10" *ngIf="extractBrandNames(item).length > 0">
                                            <span class="country-tag">
                                                <span class="location-icon-wrapper">
                                                        <img src="assets/images/brand-icon.svg" alt="Brand" 
                                                             class="location-icon" width="16" height="16">
                                                </span>
                                                <span class="country-text">
                                                    {{ displayBrandNames(item).firstTwo }}
                                                </span>
                                                <span class="count-with-space" *ngIf="displayBrandNames(item).remainingCount > 0">
                                                    +{{ displayBrandNames(item).remainingCount }}
                                                </span>
                                            </span>
                                        </p>
                                        <p class="p-b-10" *ngIf="extractCountries(item).length > 0">
                                            <span class="country-tag">
                                                <span class="location-icon-wrapper">
                                                        <img src="assets/images/location.svg" alt="Location" 
                                                             class="location-icon" width="16" height="16">
                                                </span>
                                                <span class="country-text">
                                                    {{ displayCountries(item).firstTwo }}
                                                </span>
                                                <span class="count-with-space" *ngIf="displayCountries(item).remainingCount > 0">
                                                    +{{ displayCountries(item).remainingCount }}
                                                </span>
                                            </span>
                                        </p>
                                        </ng-container>
                                    </ng-container>
                                    
                                </ng-container>
                            </div>
                            </div>
                        </div>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- Slide Indicator with Arrows -->
    <div class="slide-indicator m-b-4">
        <button class="carousel-arrow left-arrow" (click)="prevSlide()" [disabled]="currentIndex === 0">
            ←
        </button>
        <span>{{ currentIndex + 1 }}-{{ endIndex }} {{'OF_TEXT' | translate}} {{ getTotalItems() }}</span>
        <button class="carousel-arrow right-arrow" (click)="nextSlide()" [disabled]="currentIndex + 3 >= getTotalItems()">
            →
        </button>
    </div>
</div>